import { render } from "./FooterSection.vue?vue&type=template&id=0268bf18&scoped=true"
const script = {}

import "./FooterSection.vue?vue&type=style&index=0&id=0268bf18&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0268bf18"]])

export default __exports__